import { makeStyles } from '@material-ui/core/styles';

import { fontWeight } from 'theme/typography';

export const useStyles = makeStyles(theme => {
  return {
    container: {
      width: '100%',
      minHeight: theme.spacing(15.375),
      padding: theme.spacing(2.5, 2.5, 0, 2.5),
      backgroundColor: theme.palette.gray.dark,
      borderRadius: theme.spacing(2),
    },
    title: {
      fontSize: theme.typography.h5.fontSize,
      margin: 0,
      fontWeight: fontWeight.bold,
      width: '100%',
      height: theme.spacing(2),
    },
    statusContainer: {
      position: 'relative',
    },
    assetIcon: {
      height: theme.spacing(5.25),
    },
    statusIcon: {
      position: 'absolute',
      top: 14,
      left: '50%',
      transform: 'translate(-50%)',
      zIndex: 1,
      height: 14,
      width: 14,
    },
    treeDotIcon: {
      height: theme.spacing(1.5),
    },
    breakLine: {
      width: '100%',
      border: 0,
      borderTop: `1px solid ${theme.palette.gray.light}`,
      margin: 0,
    },
    bottomIcon: {
      height: theme.spacing(1.75),
      width: theme.spacing(1.75),
    },
  };
});
